import React from "react";
import Card from "components/card";
import Chart from "react-apexcharts";

const CrawlerImageStatsChart = ({ rows }) => {
  const data = React.useMemo(() => {
    let withImages = 0;
    let withoutImages = 0;
    let totalImageCount = 0;

    (rows || []).forEach((row) => {
      if (row?.imageURL) {
        withImages++;
        totalImageCount += String(row.imageURL).split(",").filter(Boolean).length;
      } else {
        withoutImages++;
      }
    });

    return { withImages, withoutImages, totalImageCount };
  }, [rows]);

  const total = data.withImages + data.withoutImages;

  if (total === 0) {
    return (
      <Card extra="p-5">
        <h4 className="text-base font-bold text-navy-700 dark:text-white mb-4 font-dm">
          Image Coverage
        </h4>
        <div className="flex items-center justify-center h-64">
          <p className="text-gray-500 dark:text-gray-400 text-sm">No data available</p>
        </div>
      </Card>
    );
  }

  const percentage = ((data.withImages / total) * 100).toFixed(1);

  return (
    <Card extra="p-5">
      <h4 className="text-base font-bold text-navy-700 dark:text-white mb-1 font-dm">
        Image Coverage
      </h4>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4 font-dm">
        {data.totalImageCount} total images across {data.withImages} retailers
      </p>
      <div className="flex items-center justify-center" style={{ minHeight: 220 }}>
        <Chart
          type="radialBar"
          height={240}
          width={240}
          series={[parseFloat(percentage)]}
          options={{
            chart: {
              type: "radialBar",
              fontFamily: "DM Sans, sans-serif",
            },
            plotOptions: {
              radialBar: {
                hollow: { size: "60%" },
                track: {
                  background: "#e5e7eb",
                  strokeWidth: "100%",
                },
                dataLabels: {
                  name: {
                    show: true,
                    fontSize: "13px",
                    fontFamily: "DM Sans, sans-serif",
                    offsetY: -8,
                    color: "#6b7280",
                  },
                  value: {
                    show: true,
                    fontSize: "24px",
                    fontWeight: 700,
                    fontFamily: "DM Sans, sans-serif",
                    color: "#1e293b",
                    formatter: (val) => val + "%",
                  },
                },
              },
            },
            colors: ["#f59e0b"],
            labels: ["With Images"],
            stroke: { lineCap: "round" },
          }}
        />
      </div>
      <div className="mt-2 grid grid-cols-2 gap-3">
        <div className="rounded-lg bg-amber-50 p-3 text-center dark:bg-amber-900/20">
          <p className="text-lg font-bold text-amber-700 dark:text-amber-300 font-dm">{data.withImages}</p>
          <p className="text-xs text-amber-600 dark:text-amber-400 font-dm">With Images</p>
        </div>
        <div className="rounded-lg bg-gray-50 p-3 text-center dark:bg-gray-700">
          <p className="text-lg font-bold text-gray-700 dark:text-gray-200 font-dm">{data.withoutImages}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 font-dm">Without Images</p>
        </div>
      </div>
    </Card>
  );
};

export default CrawlerImageStatsChart;
